module.exports = __webpack_public_path__ + "img/Russia.177519fa.webp";